// extracted by mini-css-extract-plugin
export var info = "ContactInfo-module--info--20JKl";
export var info__group = "ContactInfo-module--info__group--35zfz";
export var info__label = "ContactInfo-module--info__label--17aWh";
export var info__value = "ContactInfo-module--info__value--EeTzg";